<template>
  <a-modal
    :title="title"
    :width="800"
    :ok=false
    :visible="visible"
    :confirmLoading="confirmLoading"
    :okButtonProps="{ props: {disabled: disableSubmit} }"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">
        <a-spin :spinning="confirmLoading">
          <a-form :form="form">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="用户账号">
              <a-input v-model="model.username"  readOnly   placeholder="请输入用户账号"/>
            </a-form-item>
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="用户姓名">
              <a-input v-model="model.realname"  readOnly   placeholder="用户姓名"/>
            </a-form-item>
          </a-form>



          <a-form-item

            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="区域">
            <a-dropdown style="float: left" :trigger="['click']" placement="topCenter">
              <a-menu slot="overlay">
                <a-menu-item key="5" @click="expandAll">展开所有</a-menu-item>
                <a-menu-item key="6" @click="closeAll">合并所有</a-menu-item>
              </a-menu>
              <a-button>
                树操作 <a-icon type="up" />
              </a-button>
            </a-dropdown>
         </a-form-item>

          <a-form-item

            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="">
            <a-row :gutter="10">
              <a-col :md="10" :sm="24">
                <a-tree
                  checkable
                  :class="treeScreenClass"
                  @check="onCheck"
                  :checkStrictly="checkStrictly"
                  :checkedKeys="checkedKeys"
                  :treeData="departTree"
                  :expandedKeys="iExpandedKeys"
                  :autoExpandParent="autoExpandParent"
                  @expand="onExpand"
                />
              </a-col>
            </a-row>


          </a-form-item>


        </a-spin>

  </a-modal>
</template>

<script>

import {queryUserAreaTreeList, addUserArea, searchByKeywords, deleteByDepartId} from '@/api/api'
import {httpAction, deleteAction, getAction, postAction, putAction} from '@/api/manage'
import { get, pick } from 'lodash';
export default {
  name: "SysUserAreaModal",
  props:{

    modalWidth:Number,
    multi:{
      type:Boolean,
      default:true
    }
  },
  data() {
    return {
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      form: this.$form.createForm(this),
      url: {
       queryByUserName:"/sys/userArea/queryByUserName",//userArea
      },
    //*****************************//
      departTree: [],
      dataList:[],
      loading: false,
      visible: false,
      disableSubmit: false,
      confirmLoading:false,
      title:"部门",
      checkedKeys:[],
      applicationId:"",
      checkedRows:[],
      checkStrictly:true,
      iExpandedKeys:[],
      autoExpandParent:true
    }
  },
  computed:{
    treeScreenClass() {
      return {
        'my-dept-select-tree': true,
        'fullscreen': this.fullscreen,
      }
    },
  },
  methods:{

    //*****************页面加载时显示用户model的代码S**************//
    init () {
      var params = {userName:this.username};//查询条件
      getAction(this.url.queryByUserName,params).then((res)=>{
        if(res.success){
          this.edit (res.result);
        }else{
          this.edit({userName:this.username,status:"0"});
        }
      })
    },
    edit (record) {
      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;
      this.$nextTick(() => {
        //this.form.setFieldsValue(pick(this.model,'userName','agentUserName','status','startTime','endTime'))
        this.form.setFieldsValue(pick( JSON.parse(JSON.stringify(record)),'userName'))
      });
    },
   //*****************页面加载时显示用户model的代码E**************//

    expandAll () {
      this.iExpandedKeys = this.dataList;
    },
    closeAll () {
      this.iExpandedKeys = []
    },

    onExpand(expandedKeys) {
      // console.log('onExpand', expandedKeys)
      this.iExpandedKeys = expandedKeys
      this.autoExpandParent = false
    },
    /*handleOk(){
      this.$emit('ok');
      this.close()
    },*/
    onCheck(checkedKeys,info){
      if(!this.multi){
        let arr = checkedKeys.checked.filter(item => this.checkedKeys.indexOf(item) < 0)
        this.checkedKeys = [...arr]
        // this.checkedRows = (this.checkedKeys.length === 0) ? [] : [info.node.dataRef]
      }else{
        if(this.checkStrictly){
          this.checkedKeys = checkedKeys.checked
        }else{
          this.checkedKeys = checkedKeys
        }
        // this.checkedRows = this.getCheckedRows(this.checkedKeys)
      }
    },

    handleOk(){
      let checkRow = this.getCheckedRows(this.checkedKeys)
      /* getAction("/sys/sysDepart/addStandardDepart",{'applicationCode':this.$store.getters.applicationCode}).then((res) => {
         if (res.success) {
           this.$emit('ok');
           this.close()
           // this.artificialPersonList = res.result;
         }
       })*/
      //*********************保存用户和区域关联关系S*******************************//
      let map={};
      map.selectedUserName = this.model.id;
      map.selectedAreas =checkRow,
      map.applicationId = this.applicationId,
      postAction("/sys/userArea/addUserAreaList", map).then((res)=> {
        if (res.success) {
          this.$message.success(res.message);
          this.$emit('ok');
          //if(that.roleDisabled)that.$emit('cleanUserName');
        }
      })


      //*********************保存用户和区域关联关系E*******************************//
      this.$emit('ok',checkRow);
      this.close()
    },
    close () {
      this.$emit('close');
      this.visible = false;
    },
    handleCancel() {
      this.close()
    },
    loadTree(applicationCode,checkIdstr,username,applicationId) {
      this.applicationId=applicationId,
      //页面显示的时候加载用户model
      this.username = username;
      this.init();
      //********************

      this.checkedKeys = [];
      if(checkIdstr){
        this.checkedKeys = checkIdstr.split(',')
      }

      this.visible = true;
      var that = this
      that.departTree = []
      queryUserAreaTreeList({"applicationCode":applicationCode}).then((res) => {
        if (res.success) {
          //部门全选后，再添加部门，选中数量增多
          this.allTreeKeys = [];
          for (let i = 0; i < res.result.length; i++) {
            let temp = res.result[i]
            that.departTree.push(temp)
            // that.setThisExpandedKeys(temp)
            // that.getAllKeys(temp);
            // console.log(temp.id)
            this.setThisExpandedKeys(temp)
          }
          this.loading = false
        }
      })
    },

    setThisExpandedKeys(node) {
      if (node.children && node.children.length > 0) {
        this.dataList.push(node.key)
        for (let a = 0; a < node.children.length; a++) {
          this.setThisExpandedKeys(node.children[a])
        }
      }
    },


    // 根据 checkedKeys 获取 rows
    getCheckedRows(checkedKeys) {
      const forChildren = (list, key) => {
        for (let item of list) {
          if (item.id === key) {
            return item
          }
          if (item.children instanceof Array) {
            let value = forChildren(item.children, key)
            if (value != null) {
              return value
            }
          }
        }
        return null
      }
      let rows = [];
      let ids = "";


      for (let key of checkedKeys) {
        let row = forChildren(this.departTree, key)
        if (row != null) {
          rows.push(row)
          ids += key + ",";
        }

      }
     //return rows
      return ids;
    },

  }
}
</script>

<style lang="less" scoped>
// 限制部门选择树高度，避免部门太多时点击确定不便
// 设置树的宽度和高度滚动条等属性
.my-dept-select-tree{
  padding-left: 148px;
  height:350px;
  width: 655px;
  &.fullscreen{
    height: calc(100vh - 250px);
  }
  overflow-y: scroll;
}
.drawer-bootom-button {
  padding-left: 148px;
  position: absolute;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 2px 2px;
}

</style>